import {
  FieldSectionSubType,
  FieldSectionType,
} from 'api/field-sections/types';
import { FieldPayload, FieldMetaData, FieldMetaDataOption } from 'api/fields';
import { RatingFieldScale } from 'api/fields/fields';

export type FieldOption = Omit<FieldMetaDataOption, 'group'> & {
  group?: { label: string; value: number };
  value?: number;
};
interface MetaData extends Omit<FieldMetaData, 'options' | 'ratingScale'> {
  options: FieldOption[];
  tags?: FieldOption[];
  ratingScale?: { label: string; value: RatingFieldScale };
}

export enum FieldType {
  SingleSelect = 'SINGLE_SELECT',
  MultiSelect = 'MULTI_SELECT',
  Rating = 'RATING',
}

// TODO: combine this and the above enum, doing this write right now coz there are lot of switch case handlings
export enum KeyEventsAndIntervalFieldTypes {
  KeyEvents = 'KEY_EVENTS',
  Intervals = 'INTERVALS',
  AnalyzeIntervals = 'ANALAYSE_INTERVALS',
}

export enum FieldDataType {
  Text = 'TEXT',
  MultiLineText = 'MULTI_LINE_TEXT',
  Number = 'NUMBER',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  User = 'USER',
  Note = 'NOTE',
}

export enum FieldTypes {
  Text = 'TEXT',
  MultiLineText = 'MULTI_LINE_TEXT',
  Number = 'NUMBER',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  SingleSelect = 'SINGLE_SELECT',
  MultiSelect = 'MULTI_SELECT',
  SingleUserSelect = 'SINGLE_USER_SELECT',
  MultiUserSelect = 'MULTI_USER_SELECT',
  Rating = 'RATING',
  Note = 'NOTE',
  Level = 'LEVEL',
}

export type FieldTypeOption = {
  label: string;
  value: FieldTypes;
  description?: React.ReactNode;
};

export type FieldSectionOption = {
  label: string;
  value: number;
  sectionType: FieldSectionType;
  sectionSubType?: FieldSectionSubType;
  private?: boolean;
};

export interface Values
  extends Omit<FieldPayload, 'fieldDataType' | 'fieldType' | 'metaData'> {
  type: FieldTypeOption;
  metaData?: MetaData;
  fieldSection: FieldSectionOption | null;
}
